module.exports = "https://trybtryb-legacy.web.app/img/astro.e83aeb16.webp";